var _polygon, _rect, _line, _line2, _line3, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventsManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "50,5 90,27.5 90,72.5 50,95 10,72.5 10,27.5",
    fill: "none",
    stroke: "#000",
    strokeWidth: 4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 32,
    width: 46,
    height: 40,
    rx: 4,
    fill: "none",
    stroke: "#000",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 44,
    x2: 73,
    y2: 44,
    stroke: "#000",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 26,
    x2: 38,
    y2: 37,
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 62,
    y1: 26,
    x2: 62,
    y2: 37,
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 55,
    r: 3,
    fill: "#000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 55,
    r: 3,
    fill: "#000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 55,
    r: 3,
    fill: "#000"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 64,
    r: 3,
    fill: "#000"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 64,
    r: 3,
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsManagement);
export default __webpack_public_path__ + "static/media/events-management.8d7afbe6c3e8255b422a305ff26a678e.svg";
export { ForwardRef as ReactComponent };